<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
export default {
  name: 'ClassPicker',
  components: {
    'vue-cal': VueCal,
  },
  data() {
    return {
      classes: [],
      classGroups: {},
      locations: {},
    }
  },
  computed: {
    formattedClasses () {
      return this.classes.map(_class => {
        const stringDate = this.$buildDate(_class.date, '{year}-{month}-{date}')
        return {
          start: `${stringDate} ${_class.start_time}`,
          end: `${stringDate} ${_class.end_time}`,
          class: `${_class.location_id} ${_class.status}`,
          //title: this.getClassGroupName(_class.class_group_id),
          title: this.classGroups[_class.class_group_id].short_name,
          id: _class.id,
        }
      })
    }
  },
  methods: {
    async getClasses () {
      this.classes = (await this.$firestore.collection('classes').get()).docs.map(doc => doc.data())
      console.log(this.classes)
    },
    getEntities (localName, remoteName) {
      return new Promise(async resolve => {
        this[localName] = (await this.$firestore.collection(remoteName).get())
          .docs.map(doc => doc.data())
          .reduce((acc, entity) => {
            acc[entity.id] = entity
            return acc
          }, {})
        resolve()
      })
    },
    onEventClick () {
      console.log('wow')
    },
  },
  async mounted () {
    await this.getEntities('classGroups', 'class_groups')
    await this.getEntities('locations', 'locations')
    this.getClasses()
  },
}
</script>

<template lang="pug">
  #class-picker-main.modal-main
    .class-picker-container.modal-container
      .title Select Class
      .content
        .locations-section
          .locations-title Locations
          .locations-holder
            .location(
              v-for='location in locations'
              :class='location.id'
            ) {{location.display_name}}
        .calendar-holder
          vue-cal#class-picker(
            default-view='month'
            :disable-views=`['day', 'year', 'years']`
            hide-weekends
            :time-from='60 * 15'
            :time-to='60 * 22'
            twelve-hour
            :on-event-click='onEventClick'
            :events='formattedClasses'
            xsmall
          )
      .action
        .button.cancel(
          @click='$modals.hide("class-picker")'
        ) Cancel
</template>

<style lang="sass" scoped>
  #class-picker-main
    .class-picker-container
      .content
        .locations-section
          .locations-title
          .locations-holder
            display: flex
            flex-wrap: wrap
            text-align: center
            padding: 0 0 16px
            .location
              color: white
              padding: 8px 16px
              margin: 8px
              border-radius: 8px
              font-size: 12px
      .action
        grid-template-columns: 150px auto
</style>